/* eslint-disable react/no-array-index-key */
import { FC } from 'react';

type unitTest = {
	name: string;
	pass: boolean;
	input: string;
	expectedResult: string;
	actualResult: string;
};

type jsError = {
	message?: string;
	stack?: string;
};

export type JsResultType = {
	logs: string[];
	tests: unitTest[];
	result: any;
	errors: jsError[];
};

export enum ResultMode {
	RESULT = 'result',
	OUTPUT = 'output',
}

type JsOnlyResultProps = {
	evaluatedResult: JsResultType;
	mode?: ResultMode;
};

const JsOnlyResult: FC<JsOnlyResultProps> = ({
	evaluatedResult,
	mode = ResultMode.OUTPUT,
}) => {
	if (!evaluatedResult) {
		return null;
	}
	const { result, logs, errors } = evaluatedResult;

	return (
		<div className="JsOnlyRenderer__code-output">
			<pre style={{ margin: 0 }}>
				{mode === ResultMode.RESULT && <div>{result}</div>}
				{mode === ResultMode.OUTPUT && (
					<div>
						{logs && logs.map((log, index) => <div key={index}>{log}</div>)}
						{errors &&
							errors.map((error, index) => (
								<div key={index} style={{ color: '#ff8181' }}>
									Error: {error?.message}
								</div>
							))}
					</div>
				)}
			</pre>
		</div>
	);
};

export default JsOnlyResult;
